import { useContext } from 'react';
import { PageHeaderContext, type PageHeaderContextType } from './page-header.context';

export const usePageHeader = (): PageHeaderContextType => {
  const context = useContext(PageHeaderContext);
  if (!context) {
    throw new Error('usePageHeader must be used within a PageHeaderProvider');
  }
  return context;
};
